<template>
  <div v-if="i18n !== undefined">
    <div class="p-1 text-red-500 text-center" v-show="error">
      <transition name="vue-fade" mode="out-in">
        <span
          ><font-awesome-icon icon="exclamation-circle" />
          {{ error_message }}</span
        >
      </transition>
    </div>
    <div class="flex flex-col" v-show="!loading && !success">
      <farm
        class="my-2"
        v-for="(farm, index) in farms"
        :key="index"
        :items="farm"
        :name="index"
        :majoration="project.application.renderer.majoration"
        :project-priorities="priority"
        :current-priority="current_priority"
        :project-rank="project.rank"
        :upgrading-priority="upgradingPriority"
        :is-first-project="is_first_project"
        @priority-selected="setPriority"
        @show-note="showNote"
        :i18n="i18n.priority"
      ></farm>
      <div>
        <p
          class="text-gray-700 text-sm"
          v-for="(v, k) in extraNotesToShow"
          :key="k"
        >
          {{ k }}
          {{ i18n[v] }}
        </p>
        <p class="text-gray-700 text-sm">** {{ i18n.note_max_nodes }}</p>
      </div>
    </div>
    <div class="w-full py-4 text-center text-gray" v-if="loading">
      <span class="text-2xl">
        <font-awesome-icon icon="spinner" spin />
      </span>
    </div>
    <transition name="vue-fade" mode="out-in">
      <div class="flex flex-col py-4 text-center text-green" v-show="success">
        <div class="py-2">
          <font-awesome-icon icon="check-circle" />
          {{ i18n.priority.label }}
          <span v-if="priority.chosen != null && priority.project != null"
            >{{ i18n.changed }} {{ priority.chosen.name }}</span
          >
          <span v-if="priority.chosen != null && priority.project == null"
            >{{ i18n.set }} {{ priority.chosen.name }}</span
          >
          !
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";
import Farm from "./Priority/Farm";

export default {
  props: ["project"],
  components: { Farm },
  data() {
    return {
      extraNotesToShow: {},
      farms: [],
      i18n: undefined,
      is_first_project: false,
      priority: {
        project: null,
        qstatus: null,
        chosen: null,
      },
      loading: true,
      error: false,
      error_message: "",
      success: false,
    };
  },
  methods: {
    setPriority(payload) {
      this.error = false;

      axios
        .post(this.endpoint, {
          priority_id: payload,
        })
        .then(({ data }) => {
          this.success = true;

          const project = data.data;
          this.priority.chosen = project.priority;
          this.$store.commit("dashboard/updateProject", project);
          this.$emit("reload");

          if (!this.priority.project) {
            this.gotoUpload(project.id);
          }
        })
        .catch((error) => {
          this.error = true;
          this.error_message =
            error.response.data.msg || error.response.data.message;
        });
    },
    gotoUpload(id) {
      this.$router.push({
        name: "project.upload",
        params: {
          id,
          type: this.$route.params.type,
          locale: this.$route.params.locale,
        },
      });
    },
    showNote(k, v) {
      this.$set(this.extraNotesToShow, k, v);
    },
  },
  computed: {
    endpoint() {
      return this.$store.state.dashboard.projects.routes.priorities.store.replace(
        ":id",
        this.project.id
      );
    },

    queued() {
      return this.priority.qstatus !== null;
    },

    current_priority() {
      return this.queued ? this.priority.qstatus : this.priority.project;
    },

    // Currently upgrading a priority while in the queue
    upgradingPriority() {
      return (
        this.queued && this.priority.project.id !== this.priority.qstatus.id
      );
    },
  },

  mounted() {
    axios
      .get(
        this.$store.state.dashboard.projects.routes.priorities.index.replace(
          ":id",
          this.project.id
        )
      )
      .then(({ data }) => {
        if (data.farms.farms) {
          // temporary
          delete data.farms["farms"];
          delete data.farms["qstatus_priority"];
          delete data.farms["project_priority"];
        }
        this.farms = data.farms;
        this.priority.project = data.project;
        this.priority.qstatus = data.qstatus;
        this.i18n = data.i18n;
        this.is_first_project = data.is_first_project;
        this.loading = false;
      })
      .catch(handleAxiosError);
  },
};
</script>
